import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import mime from 'mime-types';
import {useDispatch} from 'react-redux';
import {getInspectionData} from '../../actions/getInspectionData';
import {getFile} from '../../actions/getFile';
import Spinner from '../../../../common/components/Spinner';
import CompleteInspectionPagesView from './CompleteInspectionPages-view';
import {useCompleteInspectionContext} from '../CompleteInspectionContext';
import {convertPdfDocumentToPngArray} from '../../utils/covertPDFtoPNG';
import {showGlobalErrorMessage} from '../../../../common/actions/globalErrorMessage/showGlobalErrorMessage';
import {windowMessages as M} from '../../../Inspection/constants/windowMessages';

const CompleteInspectionPages = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    setData,
    setFiles,
    setShumaTypeID,
    accessToken,
    shumaID,
  } = useCompleteInspectionContext();

  useEffect(async () => {
    setLoading(true);
    try {
      await updateContext();
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  }, [location.search]);

  const updateContext = async () => {
    setData(null);
    setFiles(null);
    const data = await updateData();
    setShumaTypeID(data.pdfData.shumaTypeID);
    await updateFiles(data);
  };

  const updateData = async () => {
    const data = await getInspectionData({
      accessToken,
      shumaID
    });
    await setData(data);

    return data;
  };

  const updateFiles = async (data) => {
    const filesFetches = data.files.map(async file => {
      try {
        const {
          shuma_id,
          file_id,
          file_extension,
        } = file;
        const body = await getFile({
          shumaId: shuma_id,
          fileID: file_id,
          accessToken
        });
        const mediaType = mime.lookup(file_extension);

        return (mediaType === 'application/pdf')
          ? {
            ...file,
            body,
            convertedPages: await convertPdfDocumentToPngArray(body)
          }
          : {...file, body};
      } catch (e) {
        const errorMessage = (
          <>
            <div>
              <span>ישנה בעיה עם הקובץ</span>
              <span>{` - ${file.file_name}`}</span>
            </div>
            <div>אנא נסו להסיר ולהעלות את הקובץ בשנית</div>
          </>
        )
        dispatch(showGlobalErrorMessage(errorMessage, () => {
          /** the child iframe can't directly invoke parent's functions
           * but can send the message to his parent
           * I use this message to close the preview popup*/
          window.parent.postMessage(M.CLOSE_PREVIEW);
        }))
        throw new Error('error with file')
      }
    });
    const filesWithBodies = await Promise.all(filesFetches);
    setFiles(filesWithBodies);
  };

  return !loading
    ? <CompleteInspectionPagesView/>
    : <Spinner/>;
};

export default CompleteInspectionPages;
